module.exports = __webpack_public_path__ + "static/media/middle-school-online.610a24c1.jpg";